import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottomNavigationPanelComponent } from './bottom-navigation-panel.component';
import { OnceNgIfModule } from '../../common/directives/once-ng-if/once-ng-if.module';
import { LayoutRowModule } from '../../common/directives/layout-row/layout-row.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        BottomNavigationPanelComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        OnceNgIfModule,
        LayoutRowModule,
        RouterModule
    ],
    exports: [
        BottomNavigationPanelComponent
    ]
})
export class BottomNavigationPanelModule { }
